module.exports = __webpack_public_path__ + "static/about-us-01-d3c34d9024782e49a8ad7154317f72b9.jpg";